module.exports = __webpack_public_path__ + "img/newWx.eaf98e51.png";